import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getErrorSwal } from '@asamco/utils';
import { DxTextBoxModule } from 'devextreme-angular';
import { BehaviorSubject, Subject } from 'rxjs';
import { Company } from '../../interfaces/company.interface';
import { AlCompanyService } from '../../services/al-company.service';

enum RequestState {
	Unsent = 1,
	Sending = 2,
	Sent = 3,
	Error = 4
}

@Component({
	selector: 'app-company-access-request-modal',
	standalone: true,
	imports: [
		CommonModule,
		DxTextBoxModule,
		FormsModule, ReactiveFormsModule
	],
	templateUrl: './company-access-request-modal.component.html',
	styleUrl: './company-access-request-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAccessRequestModalComponent {
	public RequestState = RequestState;

	public requestState$ = new BehaviorSubject<RequestState>(RequestState.Unsent);

	public company: Company;

	public errorMessage$ = new BehaviorSubject<string>('');

	@Output()
	accessRequested = new EventEmitter<{}>();

	/**
	 *
	 */
	constructor(private service: AlCompanyService) {

	}

	public showDialog$: Subject<boolean> = new BehaviorSubject<boolean>(false);

	public show(company: Company) {
		this.company = company;

		this.requestState$.next(RequestState.Unsent);

		this.showDialog$.next(true);
	}

	public cancel(): void {
		this.showDialog$.next(false);
	}

	public sendRequest() {
		this.requestState$.next(RequestState.Sending);

		this.service.createCompanyAccessRequest(this.company.id).subscribe(
		{
			next: res => {
				this.requestState$.next(RequestState.Sent);
				this.accessRequested.emit();
				this.showDialog$.next(false);
			},
			error: err => {
				const ersw = getErrorSwal(err);
				this.errorMessage$.next(ersw.text);
				this.requestState$.next(RequestState.Error);
			}
		});
	}
}
